import { useMemo } from "react";
import { MiModal } from "@miplatform/components";
import { mdiClose, mdiEmailOutline } from "@mdi/js";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/system";
import { EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG } from "../emailFormConstants";

export const EmailPreviewModal = ({
  open,
  entity,
  attachments,
  fields,
  account,
  templateType,
  onClose,
}) => {
  const { title, color, templateConfig, getTemplate } =
    EMAIL_TEMPLATE_TYPE_TO_DRAWER_CONFIG[templateType];
  const theme = useTheme();

  const dangerouslySetInnerHTML = useMemo(
    () => ({
      __html: getTemplate({
        entity,
        fields,
        attachments,
        account,
        templateType,
        config: templateConfig,
      }),
    }),
    [
      open,
      entity,
      attachments,
      fields,
      account,
      templateType,
      templateConfig,
      getTemplate,
    ]
  );

  return (
    <MiModal
      open={open}
      title={title}
      closeModal={onClose}
      titleIcon={mdiEmailOutline}
      leftIconColor={theme.palette.primary.main}
      rightIcon={mdiClose}
      width={612}
      titleContainerStyle={{
        backgroundColor: theme.palette[color].light,
        borderColor: theme.palette[color].dark,
      }}
      contentContainerStyle={{
        overflow: "auto",
        maxHeight: 710,
        paddingBottom: 0,
      }}
    >
      <Typography fontSize={12} color="common.black" fontWeight="600" mb={2}>
        {fields.subject}
      </Typography>
      <Box dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
    </MiModal>
  );
};
